/**
 * bug 41: прокрутить к первому полю с ошибкой валидации и сфокусировать его.
 * На маленьких экранах поле с ошибкой часто проскролено — без этого кажется, что отправка
 * «ничего не сделала». Ищем инпут по name (точное / без индекса / мультиселект name[]),
 * иначе — контейнер с data-field; скроллим в центр и фокусируем.
 */
export function scrollToFirstError(errors: Record<string, any> | null | undefined): void {
    if (typeof document === "undefined" || !errors) return;
    const keys = Object.keys(errors);
    if (!keys.length) return;

    const key = keys[0];
    const base = key.split(".")[0]; // 'authority_ids.0' → 'authority_ids'
    const escape = (s: string) =>
        (window as any).CSS && CSS.escape ? CSS.escape(s) : s.replace(/"/g, '\\"');
    const selector = [
        `[name="${escape(key)}"]`,
        `[name="${escape(base)}"]`,
        `[name="${escape(base)}[]"]`,
        `[data-field="${escape(base)}"]`,
    ].join(", ");

    // Берём первый ВИДИМЫЙ матч: react-select у пустого single/multi-select может рендерить
    // скрытый <input name=".." type="hidden"> — у него нет layout, scrollIntoView по нему = no-op
    // (выглядит как «не скролит к выпадающему полю»). Видимый data-field-контейнер надёжнее.
    const nodes = Array.from(document.querySelectorAll(selector)) as HTMLElement[];
    if (!nodes.length) return;
    const el = nodes.find((n) => n.getClientRects().length > 0) ?? null;
    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "center" });

    // Фокусируем реальное поле. Если попали на контейнер-обёртку (data-field у Selector —
    // это div, focus() на нём был бы no-op), ищем фокусируемый элемент внутри
    // (у react-select это его input). Иначе фокусируем сам элемент.
    const focusableSel = "input, select, textarea, button, a[href], [tabindex]";
    const target = (el.matches(focusableSel)
        ? el
        : (el.querySelector(focusableSel) as HTMLElement | null)) as HTMLElement | null;
    if (target) {
        try {
            target.focus({ preventScroll: true } as any);
        } catch {
            target.focus();
        }
    }
}
